export const getOrderIdLabel = (orderId: string) => `#${orderId}`;
